<template>
    <div class="container-progress" @click="progressClick" v-if="scoreList && scoreList.length > 0">
        <div class="progress-item" v-for="(item, index) in scoreList" :key="index">
            <div :class="['grade-ic', gradeIconSty(item)]"></div>
            <div class="pro-line">
                <template v-if="currLevelIndex > 3">
                    <div class="g-line" :style="{ width: grayLineWith() + 'px' }" v-if="index < 5">
                        <div
                            class="h-line"
                            :style="{ width: calculateWith(item) + 'px' }"
                            v-if="currLevelIndex > index + 2"
                        ></div>
                    </div>
                    <div class="holder-line" v-else></div>
                </template>
                <template v-else>
                    <div
                        class="g-line-s"
                        :style="{ width: grayLineWith() + 'px' }"
                        v-if="index < 4"
                    >
                        <div
                            class="h-line-s"
                            :style="{ width: calculateWith(item) + 'px' }"
                            v-if="currLevelIndex > index"
                        ></div>
                    </div>
                    <div
                        class="g-line-l"
                        :style="{ width: grayLineWithMax() + 'px' }"
                        v-else-if="index === 4"
                    >
                        <div class="h-line-l" v-if="currLevelIndex > index"></div>
                    </div>
                    <div class="holder-line" v-else></div>
                </template>
                <div
                    class="grade-value"
                    :style="{ marginLeft: scoreMarginLeft(item.scoreSection) + 'px' }"
                >
                    {{ item.scoreSection }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['progressData'],
    data() {
        return {
            currLevelIndex: 1,
            maxScreen: screen.height > 812,
            scoreList: []
        };
    },
    watch: {
        progressData(newV) {
            if (newV && newV.scoreSectionList) {
                this.currLevelIndex = newV.currentLevelIndex;
                let temArr = newV.scoreSectionList;
                if (this.currLevelIndex > 3) {
                    temArr.splice(0, 2);
                    this.scoreList = temArr;
                } else {
                    temArr.splice(5, 2);
                    this.scoreList = temArr;
                }
            }
        }
    },
    methods: {
        progressClick() {
            this.$emit('OnProgressClick');
        },
        gradeIconSty(item) {
            if (item.levelIndex <= this.currLevelIndex) {
                return 'hight-ic' + item.levelIndex;
            } else {
                return 'gray-ic' + item.levelIndex;
            }
        },
        scoreMarginLeft(value) {
            if (value === 0) {
                return -14;
            }
            if (value < 1000) {
                return -21;
            }
            if (value < 10000) {
                return -22;
            }
            if (value < 100000) {
                return -24;
            }
        },
        grayLineWith() {
            if (this.currLevelIndex > 3) {
                return this.maxScreen ? 48 : 44;
            } else {
                return this.maxScreen ? 32 : 28;
            }
        },
        grayLineWithMax() {
            return this.maxScreen ? 110 : 108;
        },
        calculateWith(item) {
            if (this.currLevelIndex > 3) {
                if (item.levelIndex === this.currLevelIndex) {
                    return (
                        (this.maxScreen ? 48 : 44) *
                        ((this.progressData.totalScore - this.progressData.currentScoreSection) /
                            (this.progressData.nextScoreSection -
                                this.progressData.currentScoreSection))
                    );
                } else {
                    return this.maxScreen ? 48 : 44;
                }
            } else {
                if (item.levelIndex === this.currLevelIndex) {
                    return (
                        (this.maxScreen ? 32 : 28) *
                        ((this.progressData.totalScore - this.progressData.currentScoreSection) /
                            (this.progressData.nextScoreSection -
                                this.progressData.currentScoreSection))
                    );
                } else {
                    return this.maxScreen ? 32 : 28;
                }
            }
        }
    }
};
</script>
<style lang="less" scoped>
@asserts: '../../../../assets/growth4.0/';
.container-progress {
    margin-top: 236px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 24px;
    .progress-item {
        display: flex;
        flex-direction: row;
        .grade-ic {
            z-index: 10;
            margin-top: -7px;
            width: 23px;
            height: 18px;
            background-size: 100% 100%;
        }
        .hight-ic1 {
            background-image: url('@{asserts}h-v1@2x.png');
        }
        .hight-ic2 {
            background-image: url('@{asserts}h-v2@2x.png');
        }
        .hight-ic3 {
            background-image: url('@{asserts}h-v3@2x.png');
        }
        .hight-ic4 {
            background-image: url('@{asserts}h-v4@2x.png');
        }
        .hight-ic5 {
            background-image: url('@{asserts}h-v5@2x.png');
        }
        .hight-ic6 {
            background-image: url('@{asserts}h-v6@2x.png');
        }
        .hight-ic7 {
            background-image: url('@{asserts}h-v7@2x.png');
        }
        .hight-ic8 {
            background-image: url('@{asserts}h-v8@2x.png');
        }
        .gray-ic1 {
            background-image: url('@{asserts}g-v1@2x.png');
        }
        .gray-ic2 {
            background-image: url('@{asserts}g-v2@2x.png');
        }
        .gray-ic3 {
            background-image: url('@{asserts}g-v3@2x.png');
        }
        .gray-ic4 {
            background-image: url('@{asserts}g-v4@2x.png');
        }
        .gray-ic5 {
            background-image: url('@{asserts}g-v5@2x.png');
        }
        .gray-ic6 {
            background-image: url('@{asserts}g-v6@2x.png');
        }
        .gray-ic7 {
            background-image: url('@{asserts}g-v7@2x.png');
        }
        .gray-ic8 {
            background-image: url('@{asserts}g-v8@2x.png');
        }
        .pro-line {
            margin-left: -2px;
            margin-right: -2px;
            .g-line {
                height: 4px;
                background: linear-gradient(53deg, #b9d4ee 0%, #b5d3ee 100%);
                border-radius: 2px;
                .h-line {
                    height: 4px;
                    background: linear-gradient(270deg, #f89a3e 0%, #ffb960 100%);
                    border-radius: 2px;
                }
            }
            .g-line-s {
                height: 4px;
                background: linear-gradient(53deg, #b9d4ee 0%, #b5d3ee 100%);
                border-radius: 2px;
                .h-line-s {
                    height: 4px;
                    background: linear-gradient(270deg, #f89a3e 0%, #ffb960 100%);
                    border-radius: 2px;
                }
            }
            .g-line-l {
                height: 4px;
                background: linear-gradient(53deg, #b9d4ee 0%, #b5d3ee 100%);
                border-radius: 2px;
                .h-line-l {
                    height: 4px;
                    background: linear-gradient(270deg, #f89a3e 0%, #ffb960 100%);
                    border-radius: 2px;
                }
            }
            .holder-line {
                width: 5px;
                height: 4px;
            }
            .grade-value {
                margin-top: 14px;
                color: #678db4;
                font-size: 10px;
                font-weight: bold;
            }
        }
    }
}
</style>